import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IMigrationRequest } from 'app/common/models/migration-request.model';
import { AdminDashboardService } from '../services/admin-dashboard.service';

@Component({
  selector: 'app-table-migration',
  templateUrl: './table-migration.component.html',
  styleUrls: ['./table-migration.component.scss']
})
export class TableMigrationComponent implements OnInit {
  migrationForm: FormGroup;
  infoMigrate: any;
  isLoading = false;
  isCollapsed = true;
  successMessage = '';
  errorMessage = '';
  constructor(
    private fb: FormBuilder,
    private adminDashboardService: AdminDashboardService
  ) {
    this.migrationForm = this.fb.group({
      dbConnectionString: ['', [Validators.required]],
      googleSheetUrl: ['', [Validators.required, Validators.pattern(/^https:\/\/docs\.google\.com\/spreadsheets\/d\/.+/)]]
    });
  }

  ngOnInit(): void {
    this.adminDashboardService.getInfoMigrate().then(
      info => {
        this.infoMigrate = info;
      }
    );
  }
  async onSubmit()  {
    if (this.migrationForm.invalid) {
      return;
    }

    this.isLoading = true;
    this.successMessage = '';
    this.errorMessage = '';

    const formData: IMigrationRequest = {
      dbConnectionString: this.migrationForm.value.dbConnectionString,
      googleSheetUrl: this.migrationForm.value.googleSheetUrl
    };
    try {
      await this.adminDashboardService.startMigrate(formData);
    } catch (error) {
      console.error('Ошибка startMigrate:', error);
    } finally {
      try {
        const info = await this.adminDashboardService.getInfoMigrate();
        this.infoMigrate = info;
      } catch (error) {
        console.error('Ошибка getInfoMigrate:', error);
      }
      this.isLoading = false;
    }
    this.isLoading = false;
  }

  extractSpreadsheetId(url: string): string {
    const match = url.match(/\/spreadsheets\/d\/([a-zA-Z0-9-_]+)/);
    return match ? match[1] : '';
  }
  parseDuration(durationStr: string): string {

    const parts = durationStr.split(':');
    if (parts.length !== 3) return durationStr; // если формат неожиданный

    const hours = parseInt(parts[0], 10);
    const minutes = parseInt(parts[1], 10);
    const secondsParts = parts[2].split('.');
    const seconds = parseInt(secondsParts[0], 10);
    const milliseconds = secondsParts[1]
      ? Math.round(parseFloat('0.' + secondsParts[1]) * 1000)
      : 0;

    if (hours > 0) {
      return `${hours} ч ${minutes} мин ${seconds} сек`;
    } else if (minutes > 0) {
      return `${minutes} мин ${seconds} сек`;
    } else {
      return `${seconds}.${milliseconds} сек`;
    }
  }
}
